import React from "react";

const RETRY_REFRESHED_KEY = "retry-lazy-refreshed";

/**
 * Wraps a dynamic import for React.lazy with production-safe catch handling.
 * On chunk load failure (e.g. network error, stale chunk), reloads the page once per session
 * so the user gets a fresh bundle. If the failure persists after refresh, the error is thrown
 * to avoid an infinite reload loop.
 *
 * @param {() => Promise<{ default: React.ComponentType }>} factory - Function that returns a dynamic import() promise
 * @returns {React.LazyExoticComponent<React.ComponentType>}
 */
const lazyWithRetry = (factory) => {
  return React.lazy(() =>
    factory().catch((error) => {
      const hasRefreshed = JSON.parse(
        window.sessionStorage.getItem(RETRY_REFRESHED_KEY) || "false"
      );

      if (!hasRefreshed) {
        window.sessionStorage.setItem(RETRY_REFRESHED_KEY, "true");
        window.location.reload();
      }

      throw error;
    })
  );
};

export default lazyWithRetry;
